import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    scope: String,          // ancestor selector, toggled relative to the clicked button
    name: String,           // class name toggled on the scope
    label: String,          // selector of the label element inside the button (optional)
    expandedText: String,   // label text when open
    collapsedText: String,  // label text when closed
  }

  toggle(event) {
    if (event.type == "click") {
      event.preventDefault()
    }

    const button = event.currentTarget
    const scope = button.closest(this.scopeValue)
    const open = scope.classList.toggle(this.nameValue)

    button.setAttribute("aria-expanded", open)

    if (this.hasLabelValue) {
      button.querySelector(this.labelValue).textContent =
        open ? this.expandedTextValue : this.collapsedTextValue
    }
  }
}
